import { render } from "./LoveLife.vue?vue&type=template&id=61aa65a8&scoped=true"
import script from "./LoveLife.vue?vue&type=script&lang=js"
export * from "./LoveLife.vue?vue&type=script&lang=js"

import "./LoveLife.vue?vue&type=style&index=0&id=61aa65a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61aa65a8"]])

export default __exports__